import TheAdminLayout from "@/Pages/Admin/Includes/TheLayOut.vue";
import CreateHotelList from "@/Pages/Admin/Modules/Hotel/tab/CreateHotel";
import GeneralTab from "@/Pages/Admin/Modules/Hotel/tab/General/GeneralTab";
import Notices from "@/Pages/Admin/Modules/Hotel/tab/General/Notice/Controllers/Notice";
import Time from "@/Pages/Admin/Modules/Hotel/tab/General/Time/Controllers/Time";
import Location from "@/Pages/Admin/Modules/Hotel/tab/General/Location/Controllers/Location";
import Faq from "@/Pages/Admin/Modules/Hotel/tab/Faq/Controllers/Faq";
import HotelAmenity from "@/Pages/Admin/Modules/Hotel/tab/Amenity/Controllers/HotelAmenity";
import HotelGallery from "@/Pages/Admin/Modules/Hotel/tab/Gallery/Controllers/HotelGallery";
import HotelRoom from "@/Pages/Admin/Modules/Hotel/tab/Room/Controllers/RoomList";
import RoomTab from "@/Pages/Admin/Modules/Hotel/tab/Room/RoomTab";
import EditRoomTab from "@/Pages/Admin/Modules/Hotel/tab/Room/EditRoomTab";
import RoomGallery from "@/Pages/Admin/Modules/Hotel/tab/Room/Gallery/Controllers/RoomGallery";
import RoomPackage from "@/Pages/Admin/Modules/Hotel/tab/Room/Package/Controllers/RoomPackage";
import RoomAmenity from "@/Pages/Admin/Modules/Hotel/tab/Room/Amenity/Controller/RoomAmenity";
import PaymentMethod from "@/Pages/Admin/Modules/Hotel/tab/PaymentMethod/Controllers/PaymentMethod";
import Reservation from "@/Pages/Admin/Modules/Hotel/tab/General/Reservation/Controllers/Reservation";
import General from "@/Pages/Admin/Modules/Hotel/tab/General/General/Controllers/General";
import RoomInfo from "@/Pages/Admin/Modules/Hotel/tab/Room/Controllers/RoomInfo";
import RoomEdit from "@/Pages/Admin/Modules/Hotel/tab/Room/Controllers/RoomEdit";
import HotelList from "@/Pages/Admin/Modules/Hotel/ManageHotel/Controllers/HotelList";
import { common } from "@/Pages/Admin/Modules/Common/Services/Common";

export default [
  {
    path: "/hotel",
    name: "hotel-layout",
    title: "AdminLayout",
    component: TheAdminLayout,
    redirect: { name: "business-hotel" },
    children: [
      {
        path: "/",
        name: "business-hotel",
        component: HotelList,
      },
      {
        path: "create",
        name: "create-business-hotel",
        component: CreateHotelList,
        redirect: { name: "create-business-hotel-generaltab" },
        children: [
          {
            path: "/",
            name: "create-business-hotel-generaltab",
            component: GeneralTab,
            redirect: { name: "create-business-hotel-general" },
            children: [
              {
                path: "general",
                name: "create-business-hotel-general",
                component: General,
              },

              {
                path: "notices",
                name: "create-business-hotel-notice",
                component: Notices,
              },

              {
                path: "time",
                name: "create-business-hotel-time",
                component: Time,
              },

              {
                path: "location",
                name: "create-business-hotel-location",
                component: Location,
              },
              {
                path: "reservation",
                name: "create-business-hotel-reservation",
                component: Reservation,
              },
            ],
          },
          {
            path: "faq",
            name: "create-business-hotel-faq",
            component: Faq,
          },
          {
            path: "aminity",
            name: "create-business-hotel-amenity",
            component: HotelAmenity,
          },
          {
            path: "gallery",
            name: "create-business-hotel-gallery",
            component: HotelGallery,
          },
          {
            path: "payment/method",
            name: "create-business-hotel-payment-method",
            component: PaymentMethod,
          },
          {
            path: "room",
            name: "create-business-hotel-room",
            component: HotelRoom,
          },
          {
            path: "/",
            name: "create-business-hotel-generaltab",
            component: RoomTab,
            redirect: { name: "create-business-hotel-room-info" },
            children: [
              {
                path: "room/info",
                name: "create-business-hotel-room-info",
                component: RoomInfo,
              },
            ],
          },
          {
            path: "/",
            name: "create-business-hotel-generaltab",
            component: EditRoomTab,
            redirect: { name: "edit-business-hotel-room-info" },
            children: [
              {
                path: "room/info/edit",
                name: "edit-business-hotel-room-info",
                component: RoomEdit,
              },

              {
                path: "room/gallery",
                name: "business-hotel-room-gallery",
                component: RoomGallery,
              },
              {
                path: "room/package",
                name: "business-hotel-room-package",
                component: RoomPackage,
              },

              {
                path: "room/amenity",
                name: "business-hotel-room-amenity",
                component: RoomAmenity,
              },
            ],
          },
        ],
      },
    ],
  },
];
